import React, { useState, useEffect, useRef } from "react";import MDBox from "components/MDBox";import MDTypography from "components/MDTypography";import Grid from "@mui/material/Grid";import Autocomplete from "@mui/material/Autocomplete";import Button from "@mui/material/Button";import { useNavigate } from "react-router-dom";import DashboardLayout from "../../../../../../examples/LayoutContainers/DashboardLayout";import DashboardNavbar from "../../../../../../examples/Navbars/DashboardNavbar";import CrudService from "services/cruds-service";import "jspdf-autotable";import Footer from "../../../../../../examples/Footer";import countryOptions from "../../components/List/Countries";import MenuItem from "@mui/material/MenuItem";import { FormControlLabel, IconButton } from "@mui/material";
// Büyük formda her tuşta tüm formun yeniden çizilmesini önleyen tamponlu TextField (yazma gecikmesi)
import TextField from "components/BufferedTextField";import AddCircleIcon from "@mui/icons-material/AddCircle";import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";import Typography from "@mui/material/Typography";import MDDropzone from "../../../../../../components/MDDropzone";import Switch from "@mui/material/Switch";import UploadedFilePreview from "components/MDDropzone/UploadedFilePreview";import { useSnackbar } from "context";import AddCircle from "@mui/icons-material/AddCircle";import RemoveCircle from "@mui/icons-material/RemoveCircle";import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';import 'dayjs/locale/tr';import { t } from "langs";import Box from "@mui/material/Box";import DownloadIcon from "@mui/icons-material/Download";import MarkEmailReadIcon from "@mui/icons-material/MarkEmailRead";import Checkbox from "@mui/material/Checkbox";import { Tabs, Tab } from "@mui/material";
import { ReadOnlyBanner, ReadOnlyFieldset } from "components/ReadOnlyLock";
import Chip from "@mui/material/Chip";
import { AddRowButton, RemoveRowButton } from "components/RowActions";

const CreateCustomer = ({ isModal = false, onClose, onCreated }) => {const navigate = useNavigate();const [activeTab, setActiveTab] = useState(0);const [errors, setErrors] = useState({name: "",customerCountry: "",city: "",taxID: "",taxOffice: "",customerTypes: "",customerCategory: "",customerStatus: "",});

    const departmentOptions = [
        "Management",
        "Ocean",
        "Air",
        "Project",
        "Road",
        "Sales",
        "Pricing",
        "Finance",
    ];
    const PRICING_DEPARTMENTS = [
        {label: "Export", value: "Export"},
        {label: "Import", value: "Import"},
        {label: "All", value: "All"},
    ];

    const OPERATION_DEPARTMENTS = [
        {label: "Export", value: "Export"},
        {label: "Import", value: "Import"},
        {label: "All", value: "All"},
    ];

    const FINANCE_DEPARTMENTS = [
        {label: "Accounts Payable / AP", value: "AP"},
        {label: "Accounts Receivable / AR", value: "AR"},
    ];
    const FINANCE_TITLES = [
        {label: "Junior", value: "Junior"},
        {label: "Specialist", value: "Specialist"},
        {label: "Supervisor", value: "Supervisor"},
        {label: "Manager", value: "Manager"},
        {label: "Decision Maker", value: "Decision Maker"},
    ];

    const TOP_MGMT_DEPARTMENTS = [
        {label: "Sales", value: "Sales"},
        {label: "Operation", value: "Operation"},
        {label: "Finance", value: "Finance"},
        {label: "Procurement", value: "Procurement"},
        {label: "Supply Chain", value: "Supply Chain"},
    ];

    const COMMON_TITLES = [
        {label: "Junior", value: "Junior"},
        {label: "Specialist", value: "Specialist"},
        {label: "Supervisor", value: "Supervisor"},
        {label: "Manager", value: "Manager"},
        {label: "Decision Maker", value: "Decision Maker"},
    ];

    const TOP_MGMT_TITLES = [
        {label: "Director", value: "Director"},
        {label: "C-level", value: "C-level"},
    ];


    const {showSnackbar} = useSnackbar();


    const customerOptions = [
        {label: "Sole Proprietorship"},
        {label: "General Partnership"},
        {label: "Limited Partnership"},
        {label: "Limited Liability Company (LLC)"},
        {label: "Joint Stock Company / Corporation (Inc.)"},
        {label: "Limited Liability Partnership (LLP)"},
        {label: "Cooperative"},
        {label: "Nonprofit Association"},
        {label: "Foundation"},
        {label: "Joint Venture"},
        {label: "Holding Company"},
        {label: "Branch Office"},
        {label: "Representative Office"},
        {label: "Franchise"},
    ];

    const industriesOptions = [
        {label: "Automotive & Spare Parts"},
        {label: "Consumer Electronics"},
        {label: "Pharmaceuticals & Medical Devices"},
        {label: "Industrial Machinery & Equipment"},
        {label: "FMCG (Fast Moving Consumer Goods)"},
        {label: "Textiles & Apparel"},
        {label: "Chemicals & Hazardous Materials"},
        {label: "Oil & Energy"},
        {label: "Food & Beverage (Dry / Reefer)"},
        {label: "Construction Materials"},
        {label: "E-commerce & Retail"},
        {label: "Agricultural Products & Inputs"},
        {label: "Metals & Raw Materials"},
        {label: "Aerospace & Aviation Parts"},
        {label: "Plastic, Rubber & Packaging"},
        {label: "Trader"},
    ];
    const [loading, setLoading] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const searchParams = new URLSearchParams(location.search);
    const customerId = isModal ? null : searchParams.get("id");
    // An existing account opens read-only, like the TMS pages; "Edit" unlocks the form.
    const [readOnlyMode, setReadOnlyMode] = useState(Boolean(customerId));
    useEffect(() => {
        setReadOnlyMode(Boolean(customerId));
    }, [customerId]);
    const [successMessage, setSuccessMessage] = useState("");
    const successMessageRef = useRef(null);
    const [isActive, setIsActive] = useState(true);
    const [deactivationReason, setDeactivationReason] = useState("");
    const [warningMessage, setWarningMessage] = useState("");
    const warningRef = useRef(null);
    const [financialInfoByProduct, setFinancialInfoByProduct] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [cityLoading, setCityLoading] = useState(false);

    const [salesRepOptions, setSalesRepOptions] = useState([]);
    const [sowDocument, setSowDocument] = useState([]);
    const [sopDocument, setSopDocument] = useState([]);
    const [termLimitForm, setTermLimitForm] = useState([]);
    const [taxCertificate, setTaxCertificate] = useState([]);
    const [tradeRegistry, setTradeRegistry] = useState([]);
    const [signatureForm, setSignatureForm] = useState([]);
    const [existingFiles, setExistingFiles] = useState({
        sowDocument: "",
        sopDocument: "",
        termLimitForm: "",
        taxCertificate: "",
        tradeRegistry: "",
        signatureForm: "",
    });

    const [removedFlags, setRemovedFlags] = useState({
        sowDocument: false,
        sopDocument: false,
        termLimitForm: false,
        taxCertificate: false,
        tradeRegistry: false,
        signatureForm: false,
    });

    useEffect(() => {
        const fetchSalesReps = async () => {
            try {
                const response = await CrudService.getUsers();
                const users = response.data;

                const formattedUsers = users.map(user => ({
                    label: user.attributes.name,
                    value: user.id
                }));


                setSalesRepOptions(formattedUsers);
            } catch (error) {
                console.error("Satış temsilcileri alınamadı:", error);
            }
        };

        fetchSalesReps();
    }, []);

    useEffect(() => {
        if (!isModal && customerId) {
            setIsEditing(true);
            fetchCustomerDetails(customerId);
        } else {
            setIsEditing(false);
        }
    }, [isModal, customerId]);

    const normalizeReps = (data) => {
        if (!Array.isArray(data) || data.length === 0) {
            return [{name: "", phone: "", email: "", title: "", department: [], country: "", city: ""}];
        }
        return data.map(r => ({
            name: r.name || "",
            phone: r.phone || "",
            email: r.email || "",
            title: r.title || "",
            department: Array.isArray(r.department) ? r.department : [],
            country: r.country || "",
            city: r.city || ""
        }));
    };
    const fetchCustomerDetails = async (id) => {
        setLoading(true);
        try {
            const response = await CrudService.getCustomerById(id);
            const customerData = response.data.attributes;

            const r = customerData.references || {};
            setReferenceSource(r.source || "");

            if (r.source === "Sales Team") setReferencePerson(r.salesTeamPerson || "");
            if (r.source === "Management") {
                setReferencePerson(r.managementPerson || "");
                setIsHouseAccountRef(!!r.managementHouseAccount);
            }
            if (r.source === "External") {
                setExternalType(r.externalType || "");

                if (r.externalType === "In Person") {
                    setExternalPersonName(r.externalPersonFullName || "");
                    setExternalForwardToId(r.externalForwardToSalesRep ? String(r.externalForwardToSalesRep) : null);
                }

                if (r.externalType === "Company") {
                    setExternalCompanyId(r.externalCompany ? String(r.externalCompany) : null);
                }
            }

            setCustomerCountry(customerData.customerCountry || "");
            setSalesRep(
                Array.isArray(customerData.salesRep)
                    ? customerData.salesRep.map((rep) => ({
                        label: rep.name,
                        value: rep._id,
                    }))
                    : []
            );
            setName(customerData.name || "");
            setCity(customerData.city || "");
            setPostalCode(customerData.postalCode || "");
            setTaxID(customerData.taxID || "");
            // Saved e-Invoice status -- only valid for the tax ID it was checked for.
            if (
                customerData.eInvoice?.checkedAt &&
                customerData.eInvoice.checkedTaxID === String(customerData.taxID || "").trim()
            ) {
                setEdmLookup({
                    status: "done",
                    checkedId: customerData.eInvoice.checkedTaxID,
                    registered: Boolean(customerData.eInvoice.isRegistered),
                    title: customerData.eInvoice.title || "",
                    alias: customerData.eInvoice.alias || "",
                    environment: customerData.eInvoice.environment || "",
                    checkedAt: customerData.eInvoice.checkedAt,
                    saved: true,
                });
            }
            setTaxOffice(customerData.taxOffice || "");
            setCustomerTypes(customerData.customerTypes || "");
            setBillingAddress(customerData.billingAddress || "");
            setOperationAddress(customerData.operationAddress || "");
            setPhone(customerData.phone || "");
            setEmail(customerData.email || "");
            setWebsite(customerData.website || "");
            setRepresentatives(customerData.representatives || "");
            setPaymentTerms(customerData.paymentTerms || "");
            setCreditLimit(customerData.creditLimit || "");
            setCurrency(customerData.currency || "");
            setIban(customerData.iban || "");
            setFinanceRepresentatives(customerData.financeRepresentatives || "");
            setCustomerCategory(customerData.customerCategory || "");
            setCustomerStatus(customerData.customerStatus || "");
            setServiceType(customerData.serviceType || "");
            setRepresentatives(normalizeReps(customerData.representatives));
            setFinanceRepresentatives(normalizeReps(customerData.financeRepresentatives));
            setPricingRepresentatives(normalizeReps(customerData.pricingRepresentatives));
            setOperationRepresentatives(normalizeReps(customerData.operationRepresentatives));
            setCustomerNo(customerData.customerNo || "");
            const ci = Array.isArray(customerData.customerIndustry,
            )
                ? customerData.customerIndustry
                : (customerData.customerIndustry ? [customerData.customerIndustry] : []);
            setCustomerIndustry(ci);
            setSpecialNotes(customerData.specialNotes || "");
            setTransactionNotes(customerData.transactionNotes || "");
            setComplaintHistory(customerData.complaintHistory || "");
            setExistingFiles({
                sowDocument: customerData.sowDocument || "",
                sopDocument: customerData.sopDocument || "",
                termLimitForm: customerData.termLimitForm || "",
                taxCertificate: customerData.taxCertificate || "",
                tradeRegistry: customerData.tradeRegistry || "",
                signatureForm: customerData.signatureForm || "",
            });
            setFinancialInfoByProduct(
                customerData.financialInfoByProduct?.length
                    ? customerData.financialInfoByProduct.map((item) => ({
                        ...item,
                        bankDetails: item.bankDetails?.length
                            ? item.bankDetails
                            : [
                                {
                                    bankName: "",
                                    swiftCode: "",
                                    iban: item.iban || "",
                                    currency: item.currency || "USD",
                                },
                            ],
                    }))
                    : [
                        {
                            id: Date.now(),
                            products: [],
                            paymentTerms: 0,
                            creditLimit: 0,
                            currency: "USD",
                            dateType: "Invoice Date",
                            bankDetails: [
                                {
                                    bankName: "",
                                    swiftCode: "",
                                    iban: "",
                                    currency: "USD",
                                },
                            ],
                        },
                    ]
            );

        } catch (error) {
            console.error("Error fetching customer details:", error);
        } finally {
            setLoading(false);
        }
    };

    const [salesRep, setSalesRep] = useState([]);
    const [name, setName] = useState("");
    const [customerCountry, setCustomerCountry] = useState("");
    const [city, setCity] = useState("");
    const [postalCode, setPostalCode] = useState("");
    const [taxID, setTaxID] = useState("");
    // EDM e-Fatura lookup for the entered tax ID: { status, registered, title, alias, checkedId }
    const [edmLookup, setEdmLookup] = useState({ status: "idle" });
    const [taxOffice, setTaxOffice] = useState("");
    const [customerTypes, setCustomerTypes] = useState("");
    const [billingAddress, setBillingAddress] = useState("");
    const [operationAddress, setOperationAddress] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [website, setWebsite] = useState("");
    const [paymentTerms, setPaymentTerms] = useState(0);
    const [creditLimit, setCreditLimit] = useState(0);
    const [currency, setCurrency] = useState("");
    const [iban, setIban] = useState("");
    const [representatives, setRepresentatives] = useState([{
        name: "",
        phone: "",
        email: "",
        title: "",
        department: [],
        country: "",
        city: ""
    }]);
    const [financeRepresentatives, setFinanceRepresentatives] = useState([{
        name: "",
        phone: "",
        email: "",
        title: "",
        department: [],
        country: "",
        city: ""
    }]);
    const [pricingRepresentatives, setPricingRepresentatives] = useState([{
        name: "",
        phone: "",
        email: "",
        title: "",
        department: [],
        country: "",
        city: ""
    }]);
    const [operationRepresentatives, setOperationRepresentatives] = useState([{
        name: "",
        phone: "",
        email: "",
        title: "",
        department: [],
        country: "",
        city: ""
    }]);
    const [customerCategory, setCustomerCategory] = useState(0);
    const [customerStatus, setCustomerStatus] = useState('');
    const [houseRepText, setHouseRepText] = useState("N/A");
    const isHouseAccount = customerStatus === "House Account";
    const [serviceType, setServiceType] = useState([]);
    const [customerNo, setCustomerNo] = useState('');
    const [customerIndustry, setCustomerIndustry] = useState([]);
    const [specialNotes, setSpecialNotes] = useState('');
    const [transactionNotes, setTransactionNotes] = useState('');
    const [complaintHistory, setComplaintHistory] = useState('');
    const [referenceSource, setReferenceSource] = useState(""); // Sales Team | Management | External
    const [referencePerson, setReferencePerson] = useState(""); // Sales team/management kişi adı
    const [isHouseAccountRef, setIsHouseAccountRef] = useState(false); // only for management
    const [externalType, setExternalType] = useState(""); // In Person | Company
    const [externalPersonName, setExternalPersonName] = useState(""); // In Person -> name surname
    const [externalForwardTo, setExternalForwardTo] = useState(null); // In Person -> salesRepOptions seçimi
    const [externalCompany, setExternalCompany] = useState(null); // Company -> company option
    const [companyOptions, setCompanyOptions] = useState([]);
    const [companyLoading, setCompanyLoading] = useState(false);
    const [externalForwardToId, setExternalForwardToId] = useState(null);
    const [externalCompanyId, setExternalCompanyId] = useState(null);
    const isLightStatus = ["Prospect", "Exporter", "Importer"].includes(customerStatus);
    const salesTeamPeople = [
        "Ali Kaya Koç",
        "Emre Akbıyık",
        "Hamdi Gülşen",
    ];

    const managementPeople = [
        "Olcay Gülşen",
        "Sedat Gökmen",
        "Mehmet İkmaz",
        "Emin Kaydu",
        "Beyhan Özgün",
    ];


    useEffect(() => {
        if (referenceSource !== "External") return;
        if (externalType !== "In Person") return;
        if (!externalForwardToId) return;
        if (!salesRepOptions.length) return;

        const found = salesRepOptions.find(
            (o) => String(o.value) === String(externalForwardToId)
        );

        if (found) {
            setExternalForwardTo(found);
        }
    }, [externalForwardToId, salesRepOptions, referenceSource, externalType]);


    useEffect(() => {
        if (referenceSource !== "External") return;
        if (externalType !== "Company") return;
        if (!externalCompanyId) return;
        if (!companyOptions.length) return;

        const found = companyOptions.find(
            (o) => String(o.value) === String(externalCompanyId)
        );

        if (found) {
            setExternalCompany(found);
        }
    }, [externalCompanyId, companyOptions, referenceSource, externalType]);


    useEffect(() => {
        const fetchCompanies = async () => {
            setCompanyLoading(true);
            try {
                const res = await CrudService.getCustomers();
                const raw = res?.data?.data || res?.data || [];

                const normalized = raw
                    .map((item) => {
                        // JSON:API
                        const id = item?.id || item?._id || item?.attributes?._id;
                        const name = item?.attributes?.name || item?.name;

                        if (!name) return null;
                        return {label: String(name).toUpperCase(), value: id || String(name)};
                    })
                    .filter(Boolean);

                // duplicate temizle
                const uniq = Array.from(new Map(normalized.map((x) => [x.label, x])).values());

                setCompanyOptions(uniq);
            } catch (e) {
                console.error("Company list fetch error:", e);
                setCompanyOptions([]);
            } finally {
                setCompanyLoading(false);
            }
        };

        fetchCompanies();
    }, []);


    useEffect(() => {
        const fetchCities = async () => {
            if (!customerCountry) {
                setCityOptions([]);
                setCity("");
                return;
            }

            setCityLoading(true);
            try {
                // ✅ Burayı kendi endpoint’ine göre ayarla:
                // Örn: CrudService.getCitiesByCountry(customerCountry)
                const res = await CrudService.getCitiesByCountry(customerCountry);

                // res formatına göre normalize
                const list = res?.data?.data || res?.data || [];
                const normalized = list
                    .map((x) => (typeof x === "string" ? x : x?.name || x?.label))
                    .filter(Boolean);

                setCityOptions(normalized);
            } catch (e) {
                console.error("City list fetch error:", e);
                setCityOptions([]);
            } finally {
                setCityLoading(false);
            }
        };

        fetchCities();
    }, [customerCountry]);

    const validateRequired = (status) => {
        const next = {
            name: "",
            customerCountry: "",
            city: "",
            taxID: "",
            taxOffice: "",
            customerTypes: "",
            customerCategory: "",
            billingAddress: "",
        };

        if (!name?.trim()) next.name = "Account Name is required.";
        if (!customerCountry?.trim()) next.customerCountry = "Account Country is required.";
        if (!city?.trim()) next.city = "City is required.";
        if (!customerTypes?.trim()) next.customerTypes = "Account Type is required.";

        if (!customerCategory || Number(customerCategory) === 0) {
            next.customerCategory = "Account Category is required.";
        }
        if (!status?.trim()) next.customerStatus = "Account Status is required.";

        const isLightStatusLocal = ["Prospect", "Exporter", "Importer"].includes(status);

        if (!isLightStatusLocal) {
            if (!taxID?.trim()) next.taxID = "Tax ID is required.";
            if (!taxOffice?.trim()) next.taxOffice = "Tax Office is required.";
        }

        // ✅ TaxID veya TaxOffice girilmişse Billing Address zorunlu
        const hasAnyTaxInfo = !!taxID?.trim() || !!taxOffice?.trim();
        if (hasAnyTaxInfo && !billingAddress?.trim()) {
            next.billingAddress = "Billing Address is required when Tax ID/Tax Office is provided.";
        }

        const isValid = Object.values(next).every((v) => !v);
        return {isValid, nextErrors: next};
    };


    const submitHandler = async (e) => {
        e.preventDefault();
        const {isValid, nextErrors} = validateRequired(customerStatus);
        setErrors(nextErrors);

        if (!isValid) {
            showSnackbar("Please fill required fields.", "warning");
            return;
        }
        const customerData = {
            isActive,
            deactivationReason: isActive ? "" : deactivationReason,
            name,
            customerCountry,
            city,
            postalCode,
            salesRep: Array.isArray(salesRep) ? salesRep.map(rep => rep.value) : [],
            taxID,
            taxOffice,
            customerTypes,
            billingAddress,
            operationAddress,
            phone,
            email,
            website,
            pricingRepresentatives,
            representatives,
            financeRepresentatives,
            operationRepresentatives,
            customerCategory,
            customerStatus,
            serviceType,
            customerNo,
            customerIndustry,
            specialNotes,
            transactionNotes,
            complaintHistory,
            financialInfoByProduct,
            references: {
                source: referenceSource,
                salesTeamPerson: referenceSource === "Sales Team" ? (referencePerson || null) : null,
                managementPerson: referenceSource === "Management" ? (referencePerson || null) : null,
                managementHouseAccount: referenceSource === "Management" ? !!isHouseAccountRef : false,
                externalType: referenceSource === "External" ? externalType : null,
                externalPersonFullName: referenceSource === "External" && externalType === "In Person" ? (externalPersonName || null) : null,
                externalForwardToSalesRep: referenceSource === "External" && externalType === "In Person" ? (externalForwardTo?.value || null) : null,
                externalCompany: referenceSource === "External" && externalType === "Company" ? (externalCompany?.value || null) : null,
            },

        };

        const formData = new FormData();
        const fileMap = {
            sowDocument,
            sopDocument,
            termLimitForm,
            taxCertificate,
            tradeRegistry,
            signatureForm,
        };

        function appendFileSmart(fieldName, fileArray) {
            if (fileArray?.[0]) {
                formData.append(fieldName, fileArray[0]);
            } else if (isEditing && removedFlags[fieldName]) {
                customerData[fieldName] = null;
            }
        }

        Object.entries(fileMap).forEach(([field, arr]) => appendFileSmart(field, arr));
        formData.append("data", JSON.stringify(customerData));
        try {
            setLoading(true);
            let response;
            if (isEditing) {
                response = await CrudService.updateCustomer(formData, customerId);
                setSuccessMessage("Update customer was successfully completed.");
            } else {
                response = await CrudService.createCustomer(formData);
                setSuccessMessage("Create customer was successfully completed.");

                const createdCustomer = response?.data?.data || response?.data;
                if (isModal) {
                    onCreated?.(createdCustomer);
                    onClose?.();
                    return;
                }
            }
            if (!isModal) {
                window.scrollTo({top: 0, behavior: "smooth"});
                setTimeout(() => {
                    navigate("/customer/customer-tables/details");
                }, 3000);
            }
        } catch (err) {
            const status = err?.response?.status;
            const data = err?.response?.data
            // Backend'in senin formatın: { errors: [{ detail: "..." }] }
            const detail =
                data?.errors?.[0]?.detail ||
                data?.message ||
                data?.error ||
                (typeof data === "string" ? data : null);

            // Network/CORS durumunda response olmaz
            if (!err?.response) {
                showSnackbar(`Network error: ${err?.message || "Request failed"}`, "error");
                return;
            }

            showSnackbar(detail || `Update failed. (HTTP ${status})`, "error");
        } finally {
            setLoading(false);
        }

    };

    const cityCacheRef = useRef(new Map()); // key: countryLabel -> string[]


    const fetchCitiesByCountry = async (countryLabel) => {
        if (!countryLabel) return [];

        if (cityCacheRef.current.has(countryLabel)) {
            return cityCacheRef.current.get(countryLabel);
        }

        const resp = await CrudService.getCitiesByCountry(countryLabel);
        const raw = resp?.data?.data ?? resp?.data ?? [];
        const arr = Array.isArray(raw) ? raw : [];

        const list = arr
            .map((x) => (typeof x === "string" ? x : x?.name || x?.label || x?.city))
            .filter(Boolean);

        const normalized = Array.from(new Set(list)).sort((a, b) => a.localeCompare(b));
        cityCacheRef.current.set(countryLabel, normalized);
        return normalized;
    };


    const removeTurkishChars = (text) => {
        return text
            .replace(/ç/g, "c").replace(/Ç/g, "C").replace(/ğ/g, "g").replace(/Ğ/g, "G").replace(/ı/g, "i").replace(/İ/g, "I")
            .replace(/ö/g, "o").replace(/Ö/g, "O").replace(/ş/g, "s").replace(/Ş/g, "S").replace(/ü/g, "u").replace(/Ü/g, "U");
    };
    const generateCustomerId = async (customerName) => {
        let cleanedName = removeTurkishChars(customerName); // Türkçe karakter temizliği
        const prefix = cleanedName.slice(0, 5).toUpperCase().replace(/[^A-Z0-9]/g, ""); // Sadece harf/rakam
        let uniqueNumber = "00001";
        try {
            const existingCustomers = await CrudService.getCustomersByPrefix(prefix);
            const existingNumbers = existingCustomers
                .map((customer) => parseInt(customer.customerNo.slice(5)))
                .filter((num) => !isNaN(num));
            if (existingNumbers.length > 0) {
                const maxNumber = Math.max(...existingNumbers);
                uniqueNumber = (maxNumber + 1).toString().padStart(5, "0");
            }
        } catch (error) {
            console.error("Müşteri ID oluşturulurken hata:", error);
        }
        return `${prefix}${uniqueNumber}`;
    };


    useEffect(() => {
        if (name) {
            const updateCustomerId = async () => {
                const generatedId = await generateCustomerId(name);
                setCustomerNo(generatedId);
            };
            updateCustomerId();
        }
    }, [name]);

    const addPricingRepresentative = () => {
        setPricingRepresentatives([...pricingRepresentatives, {
            name: "", phone: "", email: "", title: "", department: [], country: "", city: ""
        }]);
    };

    const removePricingRepresentative = (index) => {
        const arr = [...pricingRepresentatives];
        arr.splice(index, 1);
        setPricingRepresentatives(arr);
    };

    const updatePricingRepresentative = (index, field, value) => {
        const arr = [...pricingRepresentatives];
        arr[index][field] = value;
        setPricingRepresentatives(arr);
    };

    const addOperationRepresentative = () => {
        setOperationRepresentatives([...operationRepresentatives, {
            name: "", phone: "", email: "", title: "", department: [], country: "", city: ""
        }]);
    };

    const removeOperationRepresentative = (index) => {
        const arr = [...operationRepresentatives];
        arr.splice(index, 1);
        setOperationRepresentatives(arr);
    };

    const updateOperationRepresentative = (index, field, value) => {
        const arr = [...operationRepresentatives];
        arr[index][field] = value;
        setOperationRepresentatives(arr);
    };


    const addRepresentative = () => {
        setRepresentatives([
            ...representatives,
            {name: "", phone: "", email: "", title: "", department: [], country: "", city: ""}
        ]);
    };

    const removeRepresentative = (index) => {
        const updated = [...representatives];
        updated.splice(index, 1);
        setRepresentatives(updated);
    };

    const updateRepresentative = (index, field, value) => {
        const updated = [...representatives];
        updated[index][field] = value;
        setRepresentatives(updated);
    };

    const addFinanceRepresentative = () => {
        setFinanceRepresentatives([
            ...financeRepresentatives,
            {name: "", phone: "", email: "", title: "", department: [], country: "", city: ""}
        ]);
    };

    const removeFinanceRepresentative = (index) => {
        const updated = [...financeRepresentatives];
        updated.splice(index, 1);
        setFinanceRepresentatives(updated);
    };

    const updateFinanceRepresentative = (index, field, value) => {
        const updated = [...financeRepresentatives];
        updated[index][field] = value;
        setFinanceRepresentatives(updated);
    };


    const handlePaymentChange = (index) => (event) => {
        let value = event.target.value;
        let numValue = value === "" ? "" : Math.max(0, Math.min(120, Number(value)));
        if (numValue > 45) {
            setWarningMessage("⚠️ For payment terms over 45 days, please contact your manager");
        } else {
            setWarningMessage("");
        }
        setFinancialInfoByProduct((prev) => {
            const updated = [...prev];
            updated[index] = {...updated[index], paymentTerms: numValue === "" ? 0 : numValue};
            return updated;
        });
    };

    const handleCreditChange = (index) => (event) => {
        let value = event.target.value;
        let numValue = value === "" ? "" : Math.max(0, Math.min(200000, Number(value)));
        setFinancialInfoByProduct((prev) => {
            const updated = [...prev];
            updated[index] = {...updated[index], creditLimit: numValue === "" ? 0 : numValue};
            return updated;
        });
    };

    const sendTermForm = () => {
        if (!email) {
            showSnackbar("Please enter the customer email address.", "warning");
            return;
        }
        fetch(`${process.env.REACT_APP_API_URL}/email/send-term-form`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`, //  ✅ EKLENDİ
            },
            body: JSON.stringify({customerEmail: email, customerName: name}),
        })
            .then((r) => r.json())
            .then((res) => {
                if (res.success) {
                    showSnackbar("The form was successfully submitted!", "success");
                } else {
                    showSnackbar(res.message || "Email sending failed.", "error");
                }
            })
            .catch((err) => {
                console.error(err);
                showSnackbar("Server error, please try again.", "error");
            });
    };

    const sendFileByEmail = async ({
                                       endpoint,
                                       uploadedFiles,
                                       existingFileUrl,
                                       customerEmail,
                                       customerName,
                                       fileFieldName = "file",
                                   }) => {
        if (!customerEmail) {
            showSnackbar("Please enter the customer email address.", "warning");
            return;
        }
        if (!(uploadedFiles?.[0] || existingFileUrl)) {
            showSnackbar("Please upload a file first or have an existing file ready.", "warning");
            return;
        }
        const fd = new FormData();
        fd.append("customerEmail", customerEmail);
        fd.append("customerName", customerName);
        if (uploadedFiles?.[0]) {
            fd.append(fileFieldName, uploadedFiles[0], uploadedFiles[0].name);
        } else if (existingFileUrl) {
            fd.append("existingFileUrl", existingFileUrl);
        }
        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}${endpoint}`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: fd,
            });
            const json = await res.json();
            if (json?.success) {
                showSnackbar("Email sent successfully!", "success");
            } else {
                showSnackbar(json?.message || "Email sending failed.", "error");
            }
        } catch (e) {
            console.error(e);
            showSnackbar("Server error, please try again.", "error");
        }
    };
    const sendSowEmail = () =>
        sendFileByEmail({
            endpoint: "/email/send-sow",
            uploadedFiles: sowDocument,
            existingFileUrl: existingFiles?.sowDocument,
            customerEmail: email,
            customerName: name,
            fileFieldName: "file",
        });
    const sendSopEmail = () =>
        sendFileByEmail({
            endpoint: "/email/send-sop",
            uploadedFiles: sopDocument,
            existingFileUrl: existingFiles?.sopDocument,
            customerEmail: email,
            customerName: name,
            fileFieldName: "file",
        });


    useEffect(() => {
        if (financialInfoByProduct.length === 0) {
            setFinancialInfoByProduct([
                {
                    id: Date.now(),
                    products: [],
                    paymentTerms: 0,
                    creditLimit: 0,
                    currency: "USD",
                    dateType: "Invoice Date",
                    bankDetails: [
                        {
                            bankName: "",
                            swiftCode: "",
                            iban: "",
                            currency: "USD",
                        },
                    ],
                },
            ]);
        }
    }, []);

    const addFinancialBlock = () => {
        setFinancialInfoByProduct([
            ...financialInfoByProduct,
            {
                id: Date.now(),
                products: [],
                dateType: "Invoice Date",
                financialTerms: {
                    road: {
                        paymentTerms: 0,
                        creditLimit: 0,
                        currency: "USD",
                    },
                    ocean: {
                        paymentTerms: 0,
                        creditLimit: 0,
                        currency: "USD",
                    },
                    air: {
                        paymentTerms: 0,
                        creditLimit: 0,
                        currency: "USD",
                    },
                },
                bankDetails: [
                    {
                        bankName: "",
                        swiftCode: "",
                        iban: "",
                        currency: "USD",
                    },
                ],
            }
        ]);
    };
    const removeFinancialBlock = (id) => {
        setFinancialInfoByProduct(financialInfoByProduct.filter((block) => block.id !== id));
    };

    const defaultFinancialTerms = {
        road: {
            paymentTerms: 0,
            creditLimit: 0,
            currency: "USD",
        },
        ocean: {
            paymentTerms: 0,
            creditLimit: 0,
            currency: "USD",
        },
        air: {
            paymentTerms: 0,
            creditLimit: 0,
            currency: "USD",
        },
    };

    const updateFinancialTerm = (financeIndex, mode, field, value) => {
        setFinancialInfoByProduct((prev) => {
            const updated = [...prev];

            const currentBlock = updated[financeIndex] || {};
            const currentFinancialTerms = {
                ...defaultFinancialTerms,
                ...(currentBlock.financialTerms || {}),
            };

            updated[financeIndex] = {
                ...currentBlock,
                financialTerms: {
                    ...currentFinancialTerms,
                    [mode]: {
                        ...defaultFinancialTerms[mode],
                        ...(currentFinancialTerms[mode] || {}),
                        [field]: value,
                    },
                },
            };

            return updated;
        });
    };

    const addBankDetail = (financeIndex) => {
        setFinancialInfoByProduct((prev) => {
            const updated = [...prev];

            const currentBankDetails = updated[financeIndex].bankDetails || [];

            updated[financeIndex] = {
                ...updated[financeIndex],
                bankDetails: [
                    ...currentBankDetails,
                    {
                        bankName: "",
                        swiftCode: "",
                        iban: "",
                        currency: "USD",
                    },
                ],
            };

            return updated;
        });
    };

    const removeBankDetail = (financeIndex, bankIndex) => {
        setFinancialInfoByProduct((prev) => {
            const updated = [...prev];

            updated[financeIndex] = {
                ...updated[financeIndex],
                bankDetails: updated[financeIndex].bankDetails.filter(
                    (_, index) => index !== bankIndex
                ),
            };

            return updated;
        });
    };

    const updateBankDetail = (financeIndex, bankIndex, field, value) => {
        setFinancialInfoByProduct((prev) => {
            const updated = [...prev];

            const bankDetails = [...(updated[financeIndex].bankDetails || [])];

            bankDetails[bankIndex] = {
                ...bankDetails[bankIndex],
                [field]: value,
            };

            updated[financeIndex] = {
                ...updated[financeIndex],
                bankDetails,
            };

            return updated;
        });
    };

    const handleDownload = (fileName) => {
        const filePath = `/files/${fileName}`;
        const link = document.createElement("a");
        link.href = filePath;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const TITLE_SX = {
        fontWeight: "bold", lineHeight: 1.15, height: 15, mb: 1, display: "-webkit-box", WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical", overflow: "hidden", textOverflow: "ellipsis", textAlign: "center",
    };
    const DROPZONE_WRAPPER_SX = {
        width: "100%",
        maxWidth: "90px",
        height: "150px",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };
    const DZ_STYLE = {height: "80px", minHeight: "80px", maxHeight: "80px", fontSize: "8px", overflow: "hidden"};

    const repCityCacheRef = useRef(new Map()); // key: country -> cities[]
    const [repCityOptionsMap, setRepCityOptionsMap] = useState({});

    const ensureCitiesLoaded = async (countryLabel) => {
        if (!countryLabel) return [];

        if (repCityCacheRef.current.has(countryLabel)) return repCityCacheRef.current.get(countryLabel);

        const list = await fetchCitiesByCountry(countryLabel);
        repCityCacheRef.current.set(countryLabel, list);
        setRepCityOptionsMap((p) => ({...p, [countryLabel]: list}));
        return list;
    };


    // Asks EDM whether the entered VKN/TCKN is a registered e-Fatura user and, if
    // so, pre-fills the account name with EDM's registered title (only when the
    // name is still empty -- an existing name is never overwritten).
    const lookupTaxIdInEdm = async () => {
        const identifier = String(taxID || "").trim();

        if (!/^\d{10,11}$/.test(identifier)) {
            setEdmLookup({ status: "idle" });
            return;
        }

        if (edmLookup.checkedId === identifier && edmLookup.status !== "error") return;

        setEdmLookup({ status: "loading", checkedId: identifier });

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/edm/check-user`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify({ identifier }),
            });
            const result = await response.json().catch(() => ({}));

            if (!response.ok || !result.success) {
                throw new Error(result.error || "EDM lookup failed.");
            }

            setEdmLookup({
                status: "done",
                checkedId: identifier,
                registered: Boolean(result.isRegistered),
                title: result.title || "",
                alias: result.alias || "",
                environment: result.environment || "",
            });

            if (result.isRegistered && result.title && !String(name || "").trim()) {
                setName(String(result.title).toUpperCase());
                setErrors((prev) => ({ ...prev, name: "" }));
            }
        } catch (error) {
            setEdmLookup({ status: "error", checkedId: identifier, message: error.message });
        }
    };

    const formContent = (
        <>
            <MDBox mb={3}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={12}>
                        <MDBox display="flex" justifyContent="flex-end" mb={1}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isActive}
                                        onChange={(e) => setIsActive(e.target.checked)}
                                        color="success"
                                    />
                                }
                                label={isActive ? "Active" : "Deactive"}
                            />
                        </MDBox>
                        {!isActive && (
                            <MDBox mb={2}>
                                <TextField
                                    type="text"
                                    label="Reason for Deactivation"
                                    value={deactivationReason}
                                    onChange={(e) => setDeactivationReason(e.target.value)}
                                    fullWidth
                                />
                            </MDBox>
                        )}
                        <MDBox mb={3} textAlign="center">
                            <div
                                ref={successMessageRef}
                                style={{
                                    backgroundColor: successMessage ? "#ECFDF3" : "transparent",
                                    color: successMessage ? "#027A48" : "transparent",
                                    border: successMessage ? "1px solid #ABEFC6" : "none",
                                    fontWeight: 600,
                                    padding: "10px",
                                    textAlign: "center",
                                    marginBottom: "10px",
                                    borderRadius: "5px",
                                    visibility: successMessage ? "visible" : "hidden",
                                }}
                            >
                                {successMessage}
                            </div>
                            <MDBox mb={1}>
                                <MDTypography variant="h3" fontWeight="bold">
                                    {isEditing
                                        ? " Edit Account Profile Details"
                                        : " Create Account Profile Details"}
                                </MDTypography>
                            </MDBox>
                            <MDTypography variant="h5" fontWeight="regular" color="secondary">
                                This information will give you more information about the Account
                                Profile. </MDTypography>
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>

            {readOnlyMode && (
                <ReadOnlyBanner
                    message="This account is in read-only view. Click Edit to make changes."
                    onEdit={() => setReadOnlyMode(false)}
                />
            )}

            <Box sx={{borderBottom: 1, borderColor: "divider", mt: 3}}>
                <Tabs
                    value={activeTab}
                    onChange={(e, val) => setActiveTab(val)}
                    centered
                >
                    <Tab label="General Information"/>
                    <Tab label="Contact List & Documents"/>
                </Tabs>
            </Box>

            <ReadOnlyFieldset readOnly={readOnlyMode}>
            <MDBox mb={3} mt={2}
                   sx={{p: 3, borderRadius: "10px", bgcolor: "background.paper", boxShadow: "none",}}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={12}>
                        {activeTab === 0 && (
                            <>
                                <MDBox>
                                    <MDBox display="flex" justifyContent="flex-end" alignItems="flex-start" gap={4}>
                                        <MDBox display="flex" flexDirection="column" alignItems="center">
                                            <MDBox display="flex" alignItems="center" gap={1}>
                                                <Button
                                                    variant="contained"
                                                    component="label"
                                                    sx={{
                                                        backgroundColor: "#ff9800",
                                                        color: "#fff",
                                                        "&:hover": {backgroundColor: "#f57c00"},
                                                        width: 160,
                                                    }}
                                                >
                                                    Upload SOW
                                                    <input
                                                        type="file"
                                                        hidden
                                                        onChange={(e) => setSowDocument(Array.from(e.target.files || []))}
                                                    />
                                                </Button>
                                                <IconButton
                                                    color="primary"
                                                    onClick={() => handleDownload("sow/Statement_of_Work.docx")}
                                                >
                                                    <DownloadIcon/>
                                                </IconButton>
                                                <IconButton
                                                    color="success"
                                                    onClick={sendSowEmail}
                                                    title="Send the SOW via email."
                                                >
                                                    <MarkEmailReadIcon/>
                                                </IconButton>
                                            </MDBox>

                                            <MDBox mt={1} width={160} textAlign="center">
                                                <UploadedFilePreview
                                                    layout="stack"
                                                    forceLabel="Current File:"
                                                    file={sowDocument?.[0] || (!removedFlags.sowDocument && existingFiles.sowDocument)}
                                                    onRemove={() => {
                                                        if (sowDocument?.length) {
                                                            setSowDocument([]);
                                                        } else {
                                                            setRemovedFlags((p) => ({...p, sowDocument: true}));
                                                        }
                                                    }}
                                                />
                                            </MDBox>
                                        </MDBox>
                                        <MDBox display="flex" flexDirection="column" alignItems="center">
                                            <MDBox display="flex" alignItems="center" gap={1}>
                                                <Button
                                                    variant="contained"
                                                    component="label"
                                                    sx={{
                                                        backgroundColor: "#1976d2",
                                                        color: "#fff",
                                                        "&:hover": {backgroundColor: "#1565c0"},
                                                        width: 160,
                                                    }}
                                                >
                                                    Upload SOP
                                                    <input
                                                        type="file"
                                                        hidden
                                                        onChange={(e) => setSopDocument(Array.from(e.target.files || []))}
                                                    />
                                                </Button>
                                                <IconButton
                                                    color="primary"
                                                    onClick={() => handleDownload("sop/SOP_Filenders.docx")}
                                                >
                                                    <DownloadIcon/>
                                                </IconButton>
                                                <IconButton
                                                    color="success"
                                                    onClick={sendSopEmail}
                                                    title="Send the SOP via email."
                                                >
                                                    <MarkEmailReadIcon/>
                                                </IconButton>
                                            </MDBox>
                                            <MDBox mt={1} width={160} textAlign="center">
                                                <UploadedFilePreview
                                                    layout="stack"
                                                    forceLabel="Current File:"
                                                    file={sopDocument?.[0] || (!removedFlags.sopDocument && existingFiles.sopDocument)}
                                                    onRemove={() => {
                                                        if (sopDocument?.length) {
                                                            setSopDocument([]);
                                                        } else {
                                                            setRemovedFlags((p) => ({...p, sopDocument: true}));
                                                        }
                                                    }}
                                                />
                                            </MDBox>
                                        </MDBox>
                                    </MDBox>
                                    <MDBox mt={3}>
                                        <MDTypography variant="h6">Basic Information</MDTypography>
                                    </MDBox>
                                    <MDBox mt={3}>
                                        <MDBox mt={2}>
                                            <Grid container spacing={2}>

                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        required
                                                        fullWidth
                                                        label={t("Account Name")}
                                                        value={name}
                                                        onChange={(e) => {
                                                            setName(e.target.value.toUpperCase());
                                                            if (errors.name) setErrors((p) => ({...p, name: ""}));
                                                        }}
                                                        error={!!errors.name}
                                                        helperText={errors.name}
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={3}>
                                                    <Autocomplete
                                                        fullWidth
                                                        options={countryOptions}
                                                        getOptionLabel={(o) => o.label}
                                                        value={customerCountry ? {label: customerCountry} : null}
                                                        onChange={(e, n) => {
                                                            setCustomerCountry(n ? n.label : "");
                                                            if (errors.customerCountry) setErrors((p) => ({
                                                                ...p,
                                                                customerCountry: ""
                                                            }));
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                required
                                                                label={t("Account Country")}
                                                                error={!!errors.customerCountry}
                                                                helperText={errors.customerCountry}
                                                                sx={{"& .MuiInputBase-root": {height: 56}}}
                                                            />
                                                        )}
                                                    />

                                                </Grid>

                                                <Grid item xs={12} sm={2}>
                                                    <Autocomplete
                                                        fullWidth
                                                        options={cityOptions}
                                                        loading={cityLoading}
                                                        value={city || null}
                                                        onChange={(e, v) => {
                                                            setCity(v || "");
                                                            if (errors.city) setErrors((p) => ({...p, city: ""}));
                                                        }}
                                                        freeSolo
                                                        onInputChange={(e, v) => {
                                                            setCity((v || "").toUpperCase());
                                                            if (errors.city) setErrors((p) => ({...p, city: ""}));
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                required
                                                                label={t("City")}
                                                                error={!!errors.city}
                                                                helperText={errors.city}
                                                                sx={{"& .MuiInputBase-root": {height: 56}}}
                                                            />
                                                        )}
                                                    />

                                                </Grid>


                                                <Grid item xs={12} sm={2}>
                                                    <TextField
                                                        fullWidth
                                                        label={t("Postal Code")}
                                                        value={postalCode}
                                                        onChange={(e) => setPostalCode(e.target.value.toUpperCase())}
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    />
                                                </Grid>
                                                {/* Service Type (multiple) */}
                                                <Grid item xs={12} md={2}>
                                                    <Autocomplete
                                                        fullWidth
                                                        multiple
                                                        options={[
                                                            {label: "Supplier", value: "Supplier"},
                                                            {label: "Consignee", value: "Consignee"},
                                                            {label: "Shipper", value: "Shipper"},
                                                            {label: "Notify", value: "Notify"},
                                                            {label: "Bill to", value: "Bill to"},
                                                            {label: "Global Partner", value: "Global Partner"},
                                                        ]}
                                                        getOptionLabel={(option) => option.label}
                                                        value={serviceType.map((type) => ({label: type, value: type}))}
                                                        onChange={(event, newValue) =>
                                                            setServiceType(newValue.map((item) => item.value))
                                                        }
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Service Type"
                                                            />
                                                        )}
                                                    />
                                                </Grid>

                                            </Grid>
                                        </MDBox>
                                    </MDBox>


                                    <MDBox mt={3}>
                                        <Grid container spacing={2}>

                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    required={!isLightStatus}
                                                    fullWidth
                                                    type="text"
                                                    label={t("Tax ID / Identity Number")}
                                                    value={taxID}
                                                    onChange={(e) => {
                                                        setTaxID(e.target.value);
                                                        if (errors.taxID) setErrors((p) => ({...p, taxID: ""}));
                                                        if (edmLookup.status !== "idle") setEdmLookup({ status: "idle" });
                                                    }}
                                                    onBlur={lookupTaxIdInEdm}
                                                    error={!!errors.taxID}
                                                    helperText={errors.taxID}
                                                    sx={{"& .MuiInputBase-root": {height: 56}}}
                                                />

                                                {edmLookup.status === "loading" && (
                                                    <MDTypography variant="caption" color="text" display="block" mt={0.5}>
                                                        Checking EDM...
                                                    </MDTypography>
                                                )}

                                                {edmLookup.status === "done" && (
                                                    <MDBox mt={0.75}>
                                                        {/* "Not registered" is only a fact when it came from the
                                                            production EDM; the EDM test service knows just a few companies. */}
                                                        <Chip
                                                            size="small"
                                                            color={
                                                                edmLookup.registered
                                                                    ? "success"
                                                                    : edmLookup.environment === "production"
                                                                        ? "default"
                                                                        : "warning"
                                                            }
                                                            variant={
                                                                !edmLookup.registered && edmLookup.environment !== "production"
                                                                    ? "outlined"
                                                                    : "filled"
                                                            }
                                                            label={
                                                                edmLookup.registered
                                                                    ? "e-Invoice user"
                                                                    : edmLookup.environment === "production"
                                                                        ? "Not an e-Invoice user (e-Archive)"
                                                                        : "Not found in EDM test list (not confirmed)"
                                                            }
                                                        />
                                                        {!edmLookup.registered && edmLookup.environment !== "production" ? (
                                                            <MDTypography variant="caption" color="text" display="block" mt={0.5}>
                                                                The EDM test service only knows a few companies. This is not a
                                                                confirmed e-Archive customer; check it against the production EDM.
                                                            </MDTypography>
                                                        ) : null}
                                                        {edmLookup.saved && edmLookup.checkedAt ? (
                                                            <MDTypography variant="caption" color="text" display="block" mt={0.5}>
                                                                Saved status, checked on{" "}
                                                                {new Date(edmLookup.checkedAt).toLocaleDateString()}
                                                            </MDTypography>
                                                        ) : null}
                                                        {edmLookup.registered && edmLookup.title ? (
                                                            <MDTypography variant="caption" color="text" display="block" mt={0.5}>
                                                                EDM title: {edmLookup.title}
                                                                {String(name || "").trim() &&
                                                                String(name).trim().toUpperCase() !==
                                                                String(edmLookup.title).trim().toUpperCase() ? (
                                                                    <>
                                                                        {" "}
                                                                        <span
                                                                            style={{ color: "#1976d2", cursor: "pointer", textDecoration: "underline" }}
                                                                            onClick={() => setName(String(edmLookup.title).toUpperCase())}
                                                                        >
                                                                            Use this name
                                                                        </span>
                                                                    </>
                                                                ) : null}
                                                            </MDTypography>
                                                        ) : null}
                                                    </MDBox>
                                                )}

                                                {edmLookup.status === "error" && (
                                                    <MDTypography variant="caption" color="error" display="block" mt={0.5}>
                                                        EDM lookup failed: {edmLookup.message}
                                                    </MDTypography>
                                                )}

                                            </Grid>

                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    required={!isLightStatus}
                                                    fullWidth
                                                    type="text"
                                                    label={t("Tax Office")}
                                                    value={taxOffice}
                                                    onChange={(e) => {
                                                        setTaxOffice(e.target.value.toUpperCase());
                                                        if (errors.taxOffice) setErrors((p) => ({...p, taxOffice: ""}));
                                                    }}
                                                    error={!!errors.taxOffice}
                                                    helperText={errors.taxOffice}
                                                    sx={{"& .MuiInputBase-root": {height: 56}}}
                                                />

                                            </Grid>

                                            <Grid item xs={12} sm={6}>
                                                <Autocomplete
                                                    fullWidth
                                                    options={customerOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={customerTypes ? {label: customerTypes} : null}
                                                    onChange={(event, newValue) => {
                                                        setCustomerTypes(newValue ? newValue.label : "");
                                                        if (errors.customerTypes) setErrors((p) => ({
                                                            ...p,
                                                            customerTypes: ""
                                                        }));
                                                    }}
                                                    isOptionEqualToValue={(option, value) => option.label === value.label}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            required
                                                            label="Account Company Types"
                                                            error={!!errors.customerTypes}
                                                            helperText={errors.customerTypes}
                                                            sx={{"& .MuiInputBase-root": {height: 56}, margin: 0}}
                                                        />
                                                    )}
                                                />

                                            </Grid>

                                            {/* Operational Information Title */}
                                            <Grid item xs={12}>
                                                <MDTypography variant="h6" mt={2}>Operational Information</MDTypography>
                                            </Grid>

                                            {/* Account Category */}
                                            <Grid item xs={12} md={3}>
                                                <MDTypography variant="body1" fontSize={15} fontWeight="regular" mt={1}>
                                                    Account Category
                                                </MDTypography>

                                                {[1, 2, 3, 4, 5].map((star) => (
                                                    <span
                                                        key={star}
                                                        onClick={() => {
                                                            setCustomerCategory(star);
                                                            if (errors.customerCategory) setErrors((p) => ({
                                                                ...p,
                                                                customerCategory: ""
                                                            }));
                                                        }}
                                                        style={{
                                                            cursor: "pointer",
                                                            color: star <= customerCategory ? "#FFD700" : "#CCCCCC",
                                                            fontSize: "24px",
                                                        }}
                                                    >
                                          ★
                                        </span>
                                                ))}

                                                {!!errors.customerCategory && (
                                                    <Typography variant="caption" color="error"
                                                                sx={{display: "block", mt: 0.5}}>
                                                        {errors.customerCategory}
                                                    </Typography>
                                                )}
                                            </Grid>

                                            {/* Account Status */}
                                            <Grid item xs={12} md={3}>
                                                <Autocomplete
                                                    fullWidth
                                                    options={[
                                                        {label: "Strategic", value: "Strategic"},
                                                        {label: "Transactional", value: "Transactional"},
                                                        {label: "Prospect", value: "Prospect"},
                                                        {label: "Target", value: "Target"},
                                                        {label: "House Account", value: "House Account"},
                                                        {label: "Sales Team", value: "Sales Team"},
                                                        {label: "Exporter", value: "Exporter"},
                                                        {label: "Importer", value: "Importer"},
                                                    ]}
                                                    getOptionLabel={(option) => option.label}
                                                    value={customerStatus ? {
                                                        label: customerStatus,
                                                        value: customerStatus
                                                    } : null}
                                                    onChange={(event, newValue) => {
                                                        const val = newValue?.value || "";
                                                        setCustomerStatus(val);

                                                        // House Account logic
                                                        if (val === "House Account") {
                                                            setSalesRep([]);
                                                            setHouseRepText("N/A");
                                                        }

                                                        // ✅ Status -> Category mapping
                                                        const statusToCategory = {
                                                            "House Account": 5,
                                                            "Strategic": 4,
                                                            "Sales Team": 4,
                                                            "Target": 3,
                                                            "Transactional": 2,
                                                            "Prospect": 1,
                                                        };

                                                        const mapped = statusToCategory[val] || 0;
                                                        setCustomerCategory(mapped);
                                                        if (["Prospect", "Exporter", "Importer"].includes(val)) {
                                                            setErrors((p) => ({...p, taxID: "", taxOffice: ""}));
                                                        }
                                                        setErrors((p) => ({...p, customerCategory: ""}));
                                                    }}

                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Account Status"
                                                            sx={{"& .MuiInputBase-root": {height: 56}}}
                                                            error={!!errors.customerStatus}
                                                            helperText={errors.customerStatus}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            {/* Account Industry */}
                                            <Grid item xs={12} md={6}>
                                                <Autocomplete
                                                    fullWidth
                                                    multiple
                                                    options={industriesOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={industriesOptions.filter((opt) =>
                                                        customerIndustry.includes(opt.label)
                                                    )}
                                                    onChange={(e, newValue) =>
                                                        setCustomerIndustry(newValue.map((item) => item.label))
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Account Industry"
                                                        />
                                                    )}
                                                />
                                            </Grid>


                                        </Grid>
                                    </MDBox>

                                    <Grid container spacing={2} mt={1}>
                                        <Grid item xs={12}>
                                            <TextField
                                                fullWidth
                                                type="text"
                                                label="Billing Address"
                                                value={billingAddress}
                                                onChange={(e) => {
                                                    setBillingAddress(e.target.value.toUpperCase());
                                                    if (errors.billingAddress) setErrors((p) => ({
                                                        ...p,
                                                        billingAddress: ""
                                                    }));
                                                }}
                                                error={!!errors.billingAddress}
                                                helperText={errors.billingAddress}
                                                sx={{"& .MuiInputBase-root": {height: 56}}}
                                            />

                                        </Grid>
                                    </Grid>

                                    <MDBox mt={3}>
                                        <Grid container spacing={2}>

                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    fullWidth
                                                    type="text"
                                                    label="Phone Number"
                                                    value={phone}
                                                    onChange={(e) => setPhone(e.target.value)}
                                                    sx={{"& .MuiInputBase-root": {height: 56}}}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    fullWidth
                                                    type="email"
                                                    label="Email Address"
                                                    value={email}
                                                    onChange={(e) => setEmail(e.target.value)}
                                                    sx={{"& .MuiInputBase-root": {height: 56}}}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={4}>
                                                <TextField
                                                    fullWidth
                                                    type="url"
                                                    label="Website"
                                                    value={website}
                                                    onChange={(e) => setWebsite(e.target.value)}
                                                    sx={{"& .MuiInputBase-root": {height: 56}}}
                                                />
                                            </Grid>

                                        </Grid>
                                    </MDBox>
                                    <MDBox mt={4}>
                                        <MDTypography variant="h6">Financial Information</MDTypography>
                                    </MDBox>

                                    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="tr">
                                        {financialInfoByProduct.map((block, index) => (
                                            <MDBox key={block.id} mt={4}>
                                                <Grid container spacing={1} alignItems="center">
                                                    <Grid item xs={4}>
                                                        <TextField
                                                            select
                                                            fullWidth
                                                            label="Payment Date Type"
                                                            value={block.dateType || "Invoice Date"}
                                                            onChange={(e) => {
                                                                const updated = [...financialInfoByProduct];
                                                                updated[index].dateType = e.target.value;
                                                                setFinancialInfoByProduct(updated);
                                                            }}
                                                            sx={{
                                                                "& .MuiInputBase-root": {
                                                                    height: 56,
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                },
                                                            }}
                                                        >
                                                            <MenuItem value="Invoice Date">Invoice Date</MenuItem>
                                                            <MenuItem value="ATD">ATD</MenuItem>
                                                            <MenuItem value="POD">POD</MenuItem>
                                                            <MenuItem value="AAD">AAD</MenuItem>
                                                        </TextField>
                                                    </Grid>
                                                    {/* Add / Remove Icon Butonları */}
                                                    <Grid item xs={1}>
                                                        <Box display="flex" justifyContent="flex-end" gap={1}>
                                                            <AddRowButton onClick={() => addFinancialBlock()} tooltip="Add financial info" />
                                                            {financialInfoByProduct.length > 1 && (
                                                                <RemoveRowButton onClick={() => removeFinancialBlock(block.id)} tooltip="Remove financial info" />
                                                            )}
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                                <MDBox mt={2}>
                                                    <Grid container spacing={2}>
                                                        {["road", "ocean", "air"].map((service) => (
                                                            <Grid item xs={12} md={4} key={service}>
                                                                <MDBox
                                                                    p={2}
                                                                    border="1px solid #ddd"
                                                                    borderRadius="10px"
                                                                    sx={{
                                                                        height: "100%",
                                                                        minHeight: 420,
                                                                        overflowY: "auto",
                                                                    }}
                                                                >
                                                                    <MDTypography
                                                                        variant="h6"
                                                                        mb={2}
                                                                        textTransform="capitalize"
                                                                        fontWeight="bold"
                                                                    >
                                                                        {service}
                                                                    </MDTypography>

                                                                    {/* Payment Terms */}
                                                                    <TextField
                                                                        fullWidth
                                                                        type="number"
                                                                        label="Payment Terms (days)"
                                                                        value={
                                                                            block.financialTerms?.[service]?.paymentTerms || 0
                                                                        }
                                                                        onChange={(e) =>
                                                                            updateFinancialTerm(
                                                                                index,
                                                                                service,
                                                                                "paymentTerms",
                                                                                Number(e.target.value)
                                                                            )
                                                                        }
                                                                        sx={{ mb: 1 }}
                                                                    />

                                                                    <input
                                                                        type="range"
                                                                        min="0"
                                                                        max="120"
                                                                        step="1"
                                                                        value={
                                                                            block.financialTerms?.[service]?.paymentTerms || 0
                                                                        }
                                                                        onChange={(e) =>
                                                                            updateFinancialTerm(
                                                                                index,
                                                                                service,
                                                                                "paymentTerms",
                                                                                Number(e.target.value)
                                                                            )
                                                                        }
                                                                        style={{
                                                                            width: "100%",
                                                                            accentColor: "#1976d2",
                                                                        }}
                                                                    />

                                                                    <MDTypography
                                                                        variant="caption"
                                                                        display="block"
                                                                        mb={2}
                                                                    >
                                                                        {block.financialTerms?.[service]?.paymentTerms || 0} Days
                                                                    </MDTypography>

                                                                    {/* Credit Limit */}
                                                                    <TextField
                                                                        fullWidth
                                                                        type="number"
                                                                        label="Credit Limit ($)"
                                                                        value={
                                                                            block.financialTerms?.[service]?.creditLimit || 0
                                                                        }
                                                                        onChange={(e) =>
                                                                            updateFinancialTerm(
                                                                                index,
                                                                                service,
                                                                                "creditLimit",
                                                                                Number(e.target.value)
                                                                            )
                                                                        }
                                                                        sx={{ mb: 1 }}
                                                                    />

                                                                    <input
                                                                        type="range"
                                                                        min="0"
                                                                        max="200000"
                                                                        step="1000"
                                                                        value={
                                                                            block.financialTerms?.[service]?.creditLimit || 0
                                                                        }
                                                                        onChange={(e) =>
                                                                            updateFinancialTerm(
                                                                                index,
                                                                                service,
                                                                                "creditLimit",
                                                                                Number(e.target.value)
                                                                            )
                                                                        }
                                                                        style={{
                                                                            width: "100%",
                                                                            accentColor: "green",
                                                                        }}
                                                                    />

                                                                    <MDTypography
                                                                        variant="caption"
                                                                        display="block"
                                                                        mb={2}
                                                                    >
                                                                        {(
                                                                            block.financialTerms?.[service]?.creditLimit || 0
                                                                        ).toLocaleString()} $
                                                                    </MDTypography>

                                                                    {/* Currency */}
                                                                    <TextField
                                                                        select
                                                                        fullWidth
                                                                        label="Currency"
                                                                        value={
                                                                            block.financialTerms?.[service]?.currency || "USD"
                                                                        }
                                                                        onChange={(e) =>
                                                                            updateFinancialTerm(
                                                                                index,
                                                                                service,
                                                                                "currency",
                                                                                e.target.value
                                                                            )
                                                                        }
                                                                    >
                                                                        <MenuItem value="USD">USD</MenuItem>
                                                                        <MenuItem value="EUR">EUR</MenuItem>
                                                                        <MenuItem value="GBP">GBP</MenuItem>
                                                                        <MenuItem value="TRY">TRY</MenuItem>
                                                                    </TextField>
                                                                </MDBox>
                                                            </Grid>
                                                        ))}
                                                    </Grid>                                                </MDBox>

                                                <MDBox mt={3}>
                                                    <Grid container spacing={2} alignItems="center">
                                                        <Grid item xs={12}>
                                                            <MDTypography variant="subtitle2" fontWeight="bold" mt={2}>
                                                                Bank Information
                                                            </MDTypography>
                                                        </Grid>

                                                        {(block.bankDetails?.length
                                                                ? block.bankDetails
                                                                : [{ bankName: "", swiftCode: "", iban: "", currency: "USD" }]
                                                        ).map((bank, bankIndex) => (
                                                            <React.Fragment key={bankIndex}>
                                                                <Grid item xs={12} md={3}>
                                                                    <TextField
                                                                        fullWidth
                                                                        label="Bank Name"
                                                                        value={bank.bankName || ""}
                                                                        onChange={(e) =>
                                                                            updateBankDetail(index, bankIndex, "bankName", e.target.value.toUpperCase())
                                                                        }
                                                                        sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={12} md={3}>
                                                                    <TextField
                                                                        fullWidth
                                                                        label="Swift Code"
                                                                        value={bank.swiftCode || ""}
                                                                        onChange={(e) =>
                                                                            updateBankDetail(index, bankIndex, "swiftCode", e.target.value.toUpperCase())
                                                                        }
                                                                        sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={12} md={3}>
                                                                    <TextField
                                                                        fullWidth
                                                                        label="IBAN"
                                                                        value={bank.iban || ""}
                                                                        onChange={(e) =>
                                                                            updateBankDetail(index, bankIndex, "iban", e.target.value.toUpperCase())
                                                                        }
                                                                        sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                    />
                                                                </Grid>

                                                                <Grid item xs={12} md={2}>
                                                                    <TextField
                                                                        select
                                                                        fullWidth
                                                                        label="Currency"
                                                                        value={bank.currency || "USD"}
                                                                        onChange={(e) =>
                                                                            updateBankDetail(index, bankIndex, "currency", e.target.value)
                                                                        }
                                                                        sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                                    >
                                                                        <MenuItem value="USD">USD</MenuItem>
                                                                        <MenuItem value="EUR">EUR</MenuItem>
                                                                        <MenuItem value="TRY">TRY</MenuItem>
                                                                        <MenuItem value="GBP">GBP</MenuItem>
                                                                    </TextField>
                                                                </Grid>

                                                                <Grid item xs={12} md={1} display="flex" justifyContent="center">
                                                                    {bankIndex === (block.bankDetails?.length || 1) - 1 && (
                                                                        <AddRowButton onClick={() => addBankDetail(index)} tooltip="Add bank account" />
                                                                    )}

                                                                    {(block.bankDetails?.length || 1) > 1 && (
                                                                        <RemoveRowButton onClick={() => removeBankDetail(index, bankIndex)} tooltip="Remove bank account" />
                                                                    )}
                                                                </Grid>
                                                            </React.Fragment>
                                                        ))}
                                                    </Grid>
                                                </MDBox>
                                            </MDBox>
                                        ))}
                                    </LocalizationProvider>

                                    <MDBox mt={3}>
                                        <MDTypography variant="h6">Technical and Specialized Areas</MDTypography>
                                    </MDBox>
                                    <Grid container spacing={2} alignItems="center" mt={2}>

                                        {/* Account ID Field */}
                                        <Grid item xs={4}>
                                            <TextField
                                                type="text"
                                                label="Account ID"
                                                value={customerNo}
                                                disabled
                                                fullWidth
                                                sx={{
                                                    "& .MuiInputBase-root": {height: 56}
                                                }}
                                            />
                                        </Grid>

                                        {/* Sales Representatives */}
                                        <Grid item xs={12} md={4}>
                                            {isHouseAccount ? (
                                                <TextField
                                                    fullWidth
                                                    type="text"
                                                    label="Sales Representatives"
                                                    value={houseRepText}
                                                    onChange={(e) => setHouseRepText(e.target.value)}
                                                    sx={{"& .MuiInputBase-root": {height: 56}}}
                                                />
                                            ) : (
                                                <Autocomplete
                                                    fullWidth
                                                    multiple
                                                    options={salesRepOptions}
                                                    getOptionLabel={(option) => option.label}
                                                    value={salesRep}
                                                    onChange={(event, newValues) => setSalesRep(newValues)}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Sales Representatives"
                                                        />
                                                    )}
                                                />
                                            )}
                                        </Grid>
                                    </Grid>
                                    <MDBox mt={3}>
                                        <MDTypography variant="h6">Notes and Additional Information</MDTypography>
                                    </MDBox>

                                    <Grid container spacing={2} alignItems="center" mt={2}>
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                type="text"
                                                label="Special Notes"
                                                value={specialNotes}
                                                onChange={(e) => setSpecialNotes(e.target.value)}
                                                fullWidth
                                                sx={{"& .MuiInputBase-root": {height: 56}}}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                type="text"
                                                label="Transaction History Notes"
                                                value={transactionNotes}
                                                onChange={(e) => setTransactionNotes(e.target.value)}
                                                fullWidth
                                                sx={{"& .MuiInputBase-root": {height: 56}}}
                                            />
                                        </Grid>
                                        {/* ✅ Support History (md=3) */}
                                        <Grid item xs={12} md={4}>
                                            <TextField
                                                type="text"
                                                label="Complaint/Support History"
                                                value={complaintHistory}
                                                onChange={(e) => setComplaintHistory(e.target.value)}
                                                fullWidth
                                                sx={{"& .MuiInputBase-root": {height: 56}}}
                                            />
                                        </Grid>

                                        {/* ✅ REFERENCES */}
                                        {/* ✅ REFERENCES */}
                                        <Grid item xs={12} md={3}>
                                            <Autocomplete
                                                fullWidth
                                                options={[
                                                    { label: "Sales Team", value: "Sales Team" },
                                                    { label: "Management", value: "Management" },
                                                    { label: "External", value: "External" },
                                                ]}
                                                getOptionLabel={(option) => option?.label || ""}
                                                value={
                                                    referenceSource
                                                        ? { label: referenceSource, value: referenceSource }
                                                        : null
                                                }
                                                onChange={(event, newValue) => {
                                                    const val = newValue?.value || "";

                                                    setReferenceSource(val);
                                                    setReferencePerson("");
                                                    setIsHouseAccountRef(false);
                                                    setExternalType("");
                                                    setExternalPersonName("");
                                                    setExternalForwardTo(null);
                                                    setExternalForwardToId(null);
                                                    setExternalCompany(null);
                                                    setExternalCompanyId(null);
                                                }}
                                                isOptionEqualToValue={(option, value) =>
                                                    option.value === value.value
                                                }
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="References (Who suggested this firm?)"
                                                        sx={{ "& .MuiInputBase-root": { height: 56 } }}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        {/* Sales Team -> person */}
                                        {referenceSource === "Sales Team" && (
                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    select
                                                    fullWidth
                                                    label="Sales Team Person"
                                                    value={referencePerson}
                                                    onChange={(e) => setReferencePerson(e.target.value)}
                                                    sx={{"& .MuiInputBase-root": {height: 56}}}
                                                >
                                                    {salesTeamPeople.map((p) => (
                                                        <MenuItem key={p} value={p}>{p}</MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>
                                        )}

                                        {/* Management -> person + House Account */}
                                        {referenceSource === "Management" && (
                                            <>
                                                <Grid item xs={12} md={3}>
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        label="Management Person"
                                                        value={referencePerson}
                                                        onChange={(e) => setReferencePerson(e.target.value)}
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    >
                                                        {managementPeople.map((p) => (
                                                            <MenuItem key={p} value={p}>{p}</MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>

                                                <Grid item xs={12} md={3} display="flex" alignItems="center">
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={isHouseAccountRef}
                                                                onChange={(e) => setIsHouseAccountRef(e.target.checked)}
                                                            />
                                                        }
                                                        label="House Account"
                                                    />
                                                </Grid>
                                            </>
                                        )}

                                        {/* External -> type */}
                                        {referenceSource === "External" && (
                                            <>
                                                <Grid item xs={12} md={3}>
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        label="External Type"
                                                        value={externalType}
                                                        onChange={(e) => setExternalType(e.target.value)}
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    >
                                                        <MenuItem value="In Person">In Person</MenuItem>
                                                        <MenuItem value="Company">Company</MenuItem>
                                                    </TextField>
                                                </Grid>

                                                {/* External In Person -> name + forward to sales rep */}
                                                {externalType === "In Person" && (
                                                    <>
                                                        <Grid item xs={12} md={3}>
                                                            <TextField
                                                                fullWidth
                                                                label="Name Surname"
                                                                value={externalPersonName}
                                                                onChange={(e) => setExternalPersonName(e.target.value)}
                                                                sx={{"& .MuiInputBase-root": {height: 56}}}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} md={3}>
                                                            <Autocomplete
                                                                fullWidth
                                                                options={salesRepOptions}
                                                                value={externalForwardTo}
                                                                onChange={(e, v) => setExternalForwardTo(v)}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Forwarded to (Sales Rep)"
                                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>
                                                    </>
                                                )}

                                                {/* External Company -> pick a company */}
                                                {externalType === "Company" && (
                                                    <Grid item xs={12} md={3}>
                                                        <Autocomplete
                                                            fullWidth
                                                            loading={companyLoading}
                                                            options={companyOptions}
                                                            getOptionLabel={(o) => o?.label || ""}
                                                            value={externalCompany}
                                                            onChange={(e, v) => setExternalCompany(v)}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Company"
                                                                    sx={{"& .MuiInputBase-root": {height: 56}}}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                )}

                                            </>
                                        )}
                                    </Grid>
                                </MDBox>

                                <Box mt={4} display="flex" justifyContent="flex-end">
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={() => setActiveTab(1)}
                                        sx={{color: "#fff"}}
                                    >
                                        Next ➡️
                                    </Button>
                                </Box>

                            </>
                        )}
                        {activeTab === 1 && (
                            <>
                                <MDBox mt={3}>
                                    <MDTypography variant="h6">Top Management</MDTypography>

                                    <Grid container spacing={2} mt={1} alignItems="center">
                                        {representatives.map((rep, index) => (
                                            <React.Fragment key={index}>
                                                <Grid item xs={12} sm={2}>
                                                    <TextField
                                                        label="Name"
                                                        value={rep.name || ""}
                                                        onChange={(e) => updateRepresentative(index, "name", e.target.value)}
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={1}>
                                                    <TextField
                                                        label="Phone"
                                                        value={rep.phone || ""}
                                                        onChange={(e) => updateRepresentative(index, "phone", e.target.value)}
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={2}>
                                                    <TextField
                                                        label="Email"
                                                        value={rep.email || ""}
                                                        onChange={(e) => updateRepresentative(index, "email", e.target.value)}
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    />
                                                </Grid>

                                                {/* ✅ Title (Director / C-level) */}
                                                <Grid item xs={12} sm={1}>
                                                    <TextField
                                                        select
                                                        label="Title"
                                                        value={rep.title || ""}
                                                        onChange={(e) => updateRepresentative(index, "title", e.target.value)}
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    >
                                                        {TOP_MGMT_TITLES.map((opt) => (
                                                            <MenuItem key={opt.value} value={opt.value}>
                                                                {opt.label}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>

                                                {/* ✅ Department (Sales/Operation/Finance/Procurement/Supply Chain) */}
                                                <Grid item xs={12} sm={2}>
                                                    <TextField
                                                        select
                                                        label="Department"
                                                        value={rep.department || ""}
                                                        onChange={(e) => updateRepresentative(index, "department", e.target.value)}
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    >
                                                        {TOP_MGMT_DEPARTMENTS.map((opt) => (
                                                            <MenuItem key={opt.value} value={opt.value}>
                                                                {opt.label}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>

                                                <Grid item xs={12} sm={2}>
                                                    <Autocomplete
                                                        options={countryOptions}
                                                        getOptionLabel={(o) => o.label}
                                                        value={rep.country ? countryOptions.find((c) => c.label === rep.country) || null : null}
                                                        onChange={async (_e, v) => {
                                                            const nextCountry = v?.label || "";
                                                            updateRepresentative(index, "country", nextCountry);
                                                            updateRepresentative(index, "city", "");
                                                            if (nextCountry) await ensureCitiesLoaded(nextCountry);
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField {...params} label="Country"
                                                                       sx={{"& .MuiInputBase-root": {height: 56}}}/>
                                                        )}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={1}>
                                                    <Autocomplete
                                                        freeSolo
                                                        disabled={!rep.country}
                                                        options={rep.country ? repCityOptionsMap[rep.country] || [] : []}
                                                        value={rep.city || ""}
                                                        onChange={(_e, v) => updateRepresentative(index, "city", v || "")}
                                                        onInputChange={(_e, v) => updateRepresentative(index, "city", v || "")}
                                                        renderInput={(params) => (
                                                            <TextField {...params} label="City" fullWidth
                                                                       sx={{"& .MuiInputBase-root": {height: 56}}}/>
                                                        )}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={1} display="flex" justifyContent="center">
                                                    {index === representatives.length - 1 && (
                                                        <AddRowButton onClick={addRepresentative} tooltip="Add representative" />
                                                    )}
                                                    {representatives.length > 1 && (
                                                        <RemoveRowButton onClick={() => removeRepresentative(index)} tooltip="Remove representative" />
                                                    )}
                                                </Grid>
                                            </React.Fragment>
                                        ))}
                                    </Grid>
                                </MDBox>
                                <MDBox mt={4}>
                                    <MDTypography variant="h6">Finance Contact Information</MDTypography>

                                    <Grid container spacing={2} mt={1} alignItems="center">
                                        {financeRepresentatives.map((rep, index) => (
                                            <React.Fragment key={index}>
                                                <Grid item xs={12} sm={2}>
                                                    <TextField
                                                        label="Name"
                                                        value={rep.name || ""}
                                                        onChange={(e) => updateFinanceRepresentative(index, "name", e.target.value)}
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={1}>
                                                    <TextField
                                                        label="Phone"
                                                        value={rep.phone || ""}
                                                        onChange={(e) => updateFinanceRepresentative(index, "phone", e.target.value)}
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={2}>
                                                    <TextField
                                                        label="Email"
                                                        value={rep.email || ""}
                                                        onChange={(e) => updateFinanceRepresentative(index, "email", e.target.value)}
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    />
                                                </Grid>

                                                {/* ✅ Title (Junior/Specialist/...) */}
                                                <Grid item xs={12} sm={1}>
                                                    <TextField
                                                        select
                                                        label="Title"
                                                        value={rep.title || ""}
                                                        onChange={(e) => updateFinanceRepresentative(index, "title", e.target.value)}
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    >
                                                        {FINANCE_TITLES.map((opt) => (
                                                            <MenuItem key={opt.value} value={opt.value}>
                                                                {opt.label}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>

                                                {/* ✅ Department (AP/AR) */}
                                                <Grid item xs={12} sm={2}>
                                                    <TextField
                                                        select
                                                        label="Department"
                                                        value={rep.department || ""}
                                                        onChange={(e) => updateFinanceRepresentative(index, "department", e.target.value)}
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    >
                                                        {FINANCE_DEPARTMENTS.map((opt) => (
                                                            <MenuItem key={opt.value} value={opt.value}>
                                                                {opt.label}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>

                                                <Grid item xs={12} sm={2}>
                                                    <Autocomplete
                                                        options={countryOptions}
                                                        getOptionLabel={(o) => o.label}
                                                        value={rep.country ? countryOptions.find((c) => c.label === rep.country) || null : null}
                                                        onChange={async (_e, v) => {
                                                            const nextCountry = v?.label || "";
                                                            updateFinanceRepresentative(index, "country", nextCountry);
                                                            updateFinanceRepresentative(index, "city", "");
                                                            if (nextCountry) await ensureCitiesLoaded(nextCountry);
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField {...params} label="Country"
                                                                       sx={{"& .MuiInputBase-root": {height: 56}}}/>
                                                        )}
                                                        isOptionEqualToValue={(a, b) => a.label === b.label}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={1}>
                                                    <Autocomplete
                                                        freeSolo
                                                        disabled={!rep.country}
                                                        options={rep.country ? repCityOptionsMap[rep.country] || [] : []}
                                                        value={rep.city || ""}
                                                        onChange={(_e, v) => updateFinanceRepresentative(index, "city", v || "")}
                                                        onInputChange={(_e, v) => updateFinanceRepresentative(index, "city", v || "")}
                                                        renderInput={(params) => (
                                                            <TextField {...params} label="City" fullWidth
                                                                       sx={{"& .MuiInputBase-root": {height: 56}}}/>
                                                        )}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={1} display="flex" justifyContent="center">
                                                    {index === financeRepresentatives.length - 1 && (
                                                        <AddRowButton onClick={addFinanceRepresentative} tooltip="Add finance representative" />
                                                    )}
                                                    {financeRepresentatives.length > 1 && (
                                                        <RemoveRowButton onClick={() => removeFinanceRepresentative(index)} tooltip="Remove finance representative" />
                                                    )}
                                                </Grid>
                                            </React.Fragment>
                                        ))}
                                    </Grid>
                                </MDBox>
                                {/* ===================== PRICING CONTACT INFORMATION ===================== */}
                                <MDBox mt={4}>
                                    <MDTypography variant="h6">Pricing Contact Information</MDTypography>

                                    <Grid container spacing={2} mt={1} alignItems="center">
                                        {pricingRepresentatives.map((rep, index) => (
                                            <React.Fragment key={index}>
                                                <Grid item xs={12} sm={2}>
                                                    <TextField
                                                        label="Name"
                                                        value={rep.name}
                                                        onChange={(e) => updatePricingRepresentative(index, "name", e.target.value)}
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={1}>
                                                    <TextField
                                                        label="Phone"
                                                        value={rep.phone}
                                                        onChange={(e) => updatePricingRepresentative(index, "phone", e.target.value)}
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={2}>
                                                    <TextField
                                                        label="Email"
                                                        value={rep.email}
                                                        onChange={(e) => updatePricingRepresentative(index, "email", e.target.value)}
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    />
                                                </Grid>

                                                {/* ✅ TITLE (select) */}
                                                <Grid item xs={12} sm={1}>
                                                    <Autocomplete
                                                        options={COMMON_TITLES}
                                                        value={rep.title ? {label: rep.title, value: rep.title} : null}
                                                        onChange={(_e, v) => updatePricingRepresentative(index, "title", v?.value || "")}
                                                        getOptionLabel={(o) => o.label}
                                                        isOptionEqualToValue={(a, b) => a.value === b.value}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Title"
                                                                fullWidth
                                                                sx={{"& .MuiInputBase-root": {height: 56}}}
                                                            />
                                                        )}
                                                    />
                                                </Grid>

                                                {/* ✅ DEPARTMENT (select: Export/Import/All) */}
                                                <Grid item xs={12} sm={2}>
                                                    <Autocomplete
                                                        options={PRICING_DEPARTMENTS}
                                                        value={rep.department ? {
                                                            label: rep.department,
                                                            value: rep.department
                                                        } : null}
                                                        onChange={(_e, v) => updatePricingRepresentative(index, "department", v?.value || "")}
                                                        getOptionLabel={(o) => o.label}
                                                        isOptionEqualToValue={(a, b) => a.value === b.value}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Depart."
                                                                fullWidth
                                                                sx={{"& .MuiInputBase-root": {height: 56}}}
                                                            />
                                                        )}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={2}>
                                                    <Autocomplete
                                                        options={countryOptions}
                                                        getOptionLabel={(o) => o.label}
                                                        value={
                                                            rep.country
                                                                ? countryOptions.find((c) => c.label === rep.country) || null
                                                                : null
                                                        }
                                                        onChange={(_e, v) => {
                                                            updatePricingRepresentative(index, "country", v?.label || "");
                                                            updatePricingRepresentative(index, "city", "");
                                                            // opsiyonel: city load fonksiyonun varsa
                                                            // if (v?.label) await ensureCitiesLoaded(v.label);
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Country"
                                                                sx={{"& .MuiInputBase-root": {height: 56}}}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(a, b) => a.label === b.label}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={1}>
                                                    <Autocomplete
                                                        freeSolo
                                                        disabled={!rep.country}
                                                        options={rep.country ? repCityOptionsMap[rep.country] || [] : []}
                                                        value={rep.city || ""}
                                                        onChange={(_e, v) => updatePricingRepresentative(index, "city", v || "")}
                                                        onInputChange={(_e, v) => updatePricingRepresentative(index, "city", v || "")}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="City"
                                                                fullWidth
                                                                sx={{"& .MuiInputBase-root": {height: 56}}}
                                                            />
                                                        )}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={1} display="flex" justifyContent="center">
                                                    {index === pricingRepresentatives.length - 1 && (
                                                        <AddRowButton onClick={addPricingRepresentative} tooltip="Add pricing representative" />
                                                    )}
                                                    {pricingRepresentatives.length > 1 && (
                                                        <RemoveRowButton onClick={() => removePricingRepresentative(index)} tooltip="Remove pricing representative" />
                                                    )}
                                                </Grid>
                                            </React.Fragment>
                                        ))}
                                    </Grid>
                                </MDBox>
                                {/* ===================== OPERATION CONTACT INFORMATION ===================== */}
                                <MDBox mt={4}>
                                    <MDTypography variant="h6">Operation Contact Information</MDTypography>

                                    <Grid container spacing={2} mt={1} alignItems="center">
                                        {operationRepresentatives.map((rep, index) => (
                                            <React.Fragment key={index}>
                                                <Grid item xs={12} sm={2}>
                                                    <TextField
                                                        label="Name"
                                                        value={rep.name}
                                                        onChange={(e) => updateOperationRepresentative(index, "name", e.target.value)}
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={1}>
                                                    <TextField
                                                        label="Phone"
                                                        value={rep.phone}
                                                        onChange={(e) => updateOperationRepresentative(index, "phone", e.target.value)}
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={2}>
                                                    <TextField
                                                        label="Email"
                                                        value={rep.email}
                                                        onChange={(e) => updateOperationRepresentative(index, "email", e.target.value)}
                                                        fullWidth
                                                        sx={{"& .MuiInputBase-root": {height: 56}}}
                                                    />
                                                </Grid>

                                                {/* ✅ TITLE (select) */}
                                                <Grid item xs={12} sm={1}>
                                                    <Autocomplete
                                                        options={COMMON_TITLES}
                                                        value={rep.title ? {label: rep.title, value: rep.title} : null}
                                                        onChange={(_e, v) => updateOperationRepresentative(index, "title", v?.value || "")}
                                                        getOptionLabel={(o) => o.label}
                                                        isOptionEqualToValue={(a, b) => a.value === b.value}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Title"
                                                                fullWidth
                                                                sx={{"& .MuiInputBase-root": {height: 56}}}
                                                            />
                                                        )}
                                                    />
                                                </Grid>

                                                {/* ✅ DEPARTMENT (select: Export/Import/All) */}
                                                <Grid item xs={12} sm={2}>
                                                    <Autocomplete
                                                        options={OPERATION_DEPARTMENTS}
                                                        value={rep.department ? {
                                                            label: rep.department,
                                                            value: rep.department
                                                        } : null}
                                                        onChange={(_e, v) => updateOperationRepresentative(index, "department", v?.value || "")}
                                                        getOptionLabel={(o) => o.label}
                                                        isOptionEqualToValue={(a, b) => a.value === b.value}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Depart."
                                                                fullWidth
                                                                sx={{"& .MuiInputBase-root": {height: 56}}}
                                                            />
                                                        )}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={2}>
                                                    <Autocomplete
                                                        options={countryOptions}
                                                        getOptionLabel={(o) => o.label}
                                                        value={
                                                            rep.country
                                                                ? countryOptions.find((c) => c.label === rep.country) || null
                                                                : null
                                                        }
                                                        onChange={async (_e, v) => {
                                                            const nextCountry = v?.label || "";
                                                            updateOperationRepresentative(index, "country", nextCountry);
                                                            updateOperationRepresentative(index, "city", "");
                                                            if (nextCountry) await ensureCitiesLoaded(nextCountry);
                                                        }}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Country"
                                                                sx={{"& .MuiInputBase-root": {height: 56}}}
                                                            />
                                                        )}
                                                        isOptionEqualToValue={(a, b) => a.label === b.label}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={1}>
                                                    <Autocomplete
                                                        freeSolo
                                                        disabled={!rep.country}
                                                        options={rep.country ? repCityOptionsMap[rep.country] || [] : []}
                                                        value={rep.city || ""}
                                                        onChange={(_e, v) => updateOperationRepresentative(index, "city", v || "")}
                                                        onInputChange={(_e, v) => updateOperationRepresentative(index, "city", v || "")}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="City"
                                                                fullWidth
                                                                sx={{"& .MuiInputBase-root": {height: 56}}}
                                                            />
                                                        )}
                                                    />
                                                </Grid>

                                                <Grid item xs={12} sm={1} display="flex" justifyContent="center">
                                                    {index === operationRepresentatives.length - 1 && (
                                                        <AddRowButton onClick={addOperationRepresentative} tooltip="Add operation representative" />
                                                    )}
                                                    {operationRepresentatives.length > 1 && (
                                                        <RemoveRowButton onClick={() => removeOperationRepresentative(index)} tooltip="Remove operation representative" />
                                                    )}
                                                </Grid>
                                            </React.Fragment>
                                        ))}
                                    </Grid>
                                </MDBox>


                                <Grid container spacing={2} mt={3} justifyContent="center" alignItems="flex-start">
                                    {/* Term Limit */}
                                    <Grid item xs={12} sm={6} md={2}>
                                        <MDBox display="flex" flexDirection="column" alignItems="center">
                                            <MDTypography variant="caption" sx={TITLE_SX}>
                                                Term Limit Approval Form
                                            </MDTypography>

                                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                <MDDropzone
                                                    options={{
                                                        addRemoveLinks: true,
                                                        maxFilesize: 100, // MB
                                                        maxFiles: 1,
                                                        acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                        timeout: 0,
                                                    }}
                                                    onChange={(files) => {
                                                        setTermLimitForm(files);
                                                        setRemovedFlags((p) => ({...p, termLimitForm: false}));
                                                    }}
                                                    style={DZ_STYLE}
                                                />
                                            </MDBox>

                                            <UploadedFilePreview
                                                layout="stack"
                                                file={termLimitForm?.[0] || (!removedFlags.termLimitForm && existingFiles.termLimitForm)}
                                                onRemove={() => {
                                                    if (termLimitForm?.length) setTermLimitForm([]);
                                                    else setRemovedFlags((p) => ({...p, termLimitForm: true}));
                                                }}
                                            />

                                            <Button
                                                sx={{
                                                    mt: 2,
                                                    backgroundColor: "#1976d2",
                                                    color: "#fff",
                                                    "&:hover": {backgroundColor: "#1565c0"},
                                                }}
                                                variant="contained"
                                                onClick={sendTermForm}
                                            >
                                                Send Term Form
                                            </Button>
                                        </MDBox>
                                    </Grid>

                                    {/* Tax Certificate */}
                                    <Grid item xs={12} sm={6} md={2}>
                                        <MDBox display="flex" flexDirection="column" alignItems="center">
                                            <MDTypography variant="caption" sx={TITLE_SX}>
                                                Company Tax Certificate
                                            </MDTypography>

                                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                <MDDropzone
                                                    options={{
                                                        addRemoveLinks: true,
                                                        maxFilesize: 100,
                                                        maxFiles: 1,
                                                        acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                        timeout: 0,
                                                    }}
                                                    onChange={(files) => {
                                                        setTaxCertificate(files);
                                                        setRemovedFlags((p) => ({...p, taxCertificate: false}));
                                                    }}
                                                    style={DZ_STYLE}
                                                />
                                            </MDBox>

                                            <UploadedFilePreview
                                                layout="stack"
                                                file={taxCertificate?.[0] || (!removedFlags.taxCertificate && existingFiles.taxCertificate)}
                                                onRemove={() => {
                                                    if (taxCertificate?.length) setTaxCertificate([]);
                                                    else setRemovedFlags((p) => ({...p, taxCertificate: true}));
                                                }}
                                            />
                                        </MDBox>
                                    </Grid>

                                    {/* Trade Registry */}
                                    <Grid item xs={12} sm={6} md={2}>
                                        <MDBox display="flex" flexDirection="column" alignItems="center">
                                            <MDTypography variant="caption" sx={TITLE_SX}>
                                                Company Trade Registry
                                            </MDTypography>

                                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                <MDDropzone
                                                    options={{
                                                        addRemoveLinks: true,
                                                        maxFilesize: 100,
                                                        maxFiles: 1,
                                                        acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                        timeout: 0,
                                                    }}
                                                    onChange={(files) => {
                                                        setTradeRegistry(files);
                                                        setRemovedFlags((p) => ({...p, tradeRegistry: false}));
                                                    }}
                                                    style={DZ_STYLE}
                                                />
                                            </MDBox>

                                            <UploadedFilePreview
                                                layout="stack"
                                                file={tradeRegistry?.[0] || (!removedFlags.tradeRegistry && existingFiles.tradeRegistry)}
                                                onRemove={() => {
                                                    if (tradeRegistry?.length) setTradeRegistry([]);
                                                    else setRemovedFlags((p) => ({...p, tradeRegistry: true}));
                                                }}
                                            />
                                        </MDBox>
                                    </Grid>

                                    {/* Signature Form */}
                                    <Grid item xs={12} sm={6} md={2}>
                                        <MDBox display="flex" flexDirection="column" alignItems="center">
                                            <MDTypography variant="caption" sx={TITLE_SX}>
                                                Company Signature Circular
                                            </MDTypography>

                                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                <MDDropzone
                                                    options={{
                                                        addRemoveLinks: true,
                                                        maxFilesize: 100,
                                                        maxFiles: 1,
                                                        acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                        timeout: 0,
                                                    }}
                                                    onChange={(files) => {
                                                        setSignatureForm(files);
                                                        setRemovedFlags((p) => ({...p, signatureForm: false}));
                                                    }}
                                                    style={DZ_STYLE}
                                                />
                                            </MDBox>

                                            <UploadedFilePreview
                                                layout="stack"
                                                file={signatureForm?.[0] || (!removedFlags.signatureForm && existingFiles.signatureForm)}
                                                onRemove={() => {
                                                    if (signatureForm?.length) setSignatureForm([]);
                                                    else setRemovedFlags((p) => ({...p, signatureForm: true}));
                                                }}
                                            />
                                        </MDBox>
                                    </Grid>
                                </Grid>

                                {/* Submit Button Correct Position */}
                                <MDBox mt={6} mb={4} width="100%">
                                    <Box
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="space-between"
                                        width="100%"
                                    >
                                        <Button
                                            variant="contained"
                                            onClick={() => setActiveTab(0)}
                                            sx={{
                                                backgroundColor: "#ff7400",
                                                color: "#ffffff",
                                                fontWeight: "bold",
                                                "&:hover": {backgroundColor: "#ff7400"},
                                            }}
                                        >
                                            ⬅️ Back
                                        </Button>

                                        <Button
                                            disabled={!name?.trim()}
                                            variant="contained"
                                            color="primary"
                                            onClick={submitHandler}
                                            sx={{
                                                backgroundColor: "#0B1F3A",
                                                color: "#FFFFFF",
                                                fontWeight: "bold",
                                                fontSize: "16px",
                                                px: 5,
                                                py: 1.5,
                                                textTransform: "uppercase",
                                                "&:hover": {backgroundColor: "#43a047"},
                                            }}
                                        >
                                            {isEditing ? "Update Account" : "Create Account"}
                                        </Button>
                                    </Box>
                                </MDBox>

                            </>
                        )}
                    </Grid>

                </Grid>
            </MDBox>
            </ReadOnlyFieldset>


        </>
    );


    return isModal ? (
        formContent
    ) : (
        <DashboardLayout>
            <DashboardNavbar/>
            {formContent}
            <Footer/>
        </DashboardLayout>
    );

}
export default CreateCustomer;